import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { payrollPersonTargetsSearchSchema } from '@/features/operation-event/payroll-start-mock/payrollPersonTargetsSearchSchema';

export const Route = createFileRoute(
  '/_staff/payroll-core/_layout/person-targets/',
)({
  validateSearch: zodValidator(payrollPersonTargetsSearchSchema),
});
